import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeeService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  updateFee(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/fee/update`, payload);
  }

  getCurrentFee(): Observable<any> {
    return this.http.get(`${this.apiUrl}/fee/current`);
  }

  getFeeHistory(): Observable<any> {
    return this.http.get(`${this.apiUrl}/fee/history`);
  }
}
